export default __webpack_public_path__ + "static/media/chat-block2.281ebe6f.png";